import { FC } from "react";

import { Typography } from "@mui/material";
import { PickersCalendarHeaderProps } from "@mui/x-date-pickers-pro";
import { getLanguage } from "src/utils/Languages/LanguageContext";

const CustomCalendarHeader: FC<PickersCalendarHeaderProps> = ({
  currentMonth,
}) => {
  const language = getLanguage();

  return (
    <Typography variant="body1" sx={{ textAlign: "center", mt: "1rem" }}>
      {currentMonth.toLocaleString(language, { month: "long" })}
    </Typography>
  );
};

export default CustomCalendarHeader;
